export default __webpack_public_path__ + "static/media/mdas.f5ac446f.svg";